import React from "react";
import { Select, Tooltip } from "antd";

import ClientContainer from "./clientContainer";

const { Option } = Select;

const ClientsChoice = ({ clients, defaultClientId, onClientIdChange }) => (
  <ClientContainer>
    <Select
      onChange={onClientIdChange}
      defaultValue={defaultClientId}
      className="client-choice-select"
    >
      {clients.map((c, i) => (
        <Option key={i} value={c.id}>
          <Tooltip title={c.code}>{c.name}</Tooltip>
        </Option>
      ))}
    </Select>
  </ClientContainer>
);

export default ClientsChoice;
